// NOTE: color names from https://www.color-name.com/hex/00a995

import { createTheme } from "@mui/material/styles"
import { isFreshFinance } from "helpers/features"

export const colors = {
  antiFlashWhite: "#f0f2f8",
  black: "#000",
  brightGray: "#e7eaf0",
  brilliantAzure: "#4094f7",
  chineseSilver: "#cdcdcd",
  cultured: "#f7f7f7",
  ghostWhite: "#f9fafc",
  indigo: "#1f2c5d",
  maastrichtBlue: "#05142f",
  persianGreen: "#00a995",
  lightPersianGreen: "rgba(0, 169, 149, 0.07)",
  romanSilver: "#878e96",
  ruby: "#e01e5a",
  orchidPink: "#f6c2cb",
  white: "#fff",
  yellowOrange: "#f3a83b",
  palatinateBlue: "#3133d6",
  shampoo: "#f7cbfc",
  blueViolet: "#4e117c",
}

const fontFamily = "Inter, Arial, sans-serif"

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 800,
    lg: 1280,
    xl: 1536,
  },
}

const typography = {
  htmlFontSize: 16,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 500,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  fontFamily: fontFamily,
  h1: {
    fontFamily,
    fontSize: "2.25rem",
    fontWeight: 600,
  },
  h2: {
    fontFamily,
    fontSize: "2.125rem",
    fontWeight: 600,
  },
  h3: {
    fontFamily: fontFamily,
    fontSize: "1.75rem",
    fontWeight: 600,
  },
  h4: {
    fontFamily: fontFamily,
    fontSize: "1.375rem",
    fontWeight: 600,
  },
  h5: {
    fontFamily: fontFamily,
    fontSize: "1.25rem",
    fontWeight: 600,
  },
  h6: {
    fontFamily: fontFamily,
    fontSize: "1rem",
    fontWeight: 300,
  },
  subtitle1: {
    fontFamily: fontFamily,
    fontSize: "1rem",
    fontWeight: 400,
  },
  subtitle2: {
    fontFamily,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  body1: {
    fontFamily,
    fontSize: "1rem",
    fontWeight: 400,
  },
  body2: {
    fontFamily,
    fontSize: "1rem",
    fontWeight: 600,
  },
  button: {
    fontFamily,
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  caption: {
    fontFamily,
    fontSize: "0.6875rem",
    fontWeight: 400,
  },
  overline: {
    fontFamily,
    fontSize: "0.75rem",
    fontWeight: 400,
  },
}

const freshfinanceTheme = createTheme({
  breakpoints: breakpoints,
  typography: typography,
  palette: {
    mode: "light",
    common: {
      black: colors.black,
      white: colors.white,
    },
    primary: {
      main: colors.persianGreen,
    },
    secondary: {
      main: colors.indigo,
    },
    error: {
      main: colors.ruby,
    },
    warning: {
      main: colors.ruby,
    },
    info: {
      main: colors.brilliantAzure,
    },
    success: {
      main: colors.persianGreen,
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    aside: {
      main: colors.maastrichtBlue,
      background: colors.indigo,
    },
    background: {
      default: colors.ghostWhite,
    },
    text: {
      primary: colors.indigo,
    },
  },
})

const punkfinanceTheme = createTheme({
  breakpoints,
  typography,
  palette: {
    mode: "light",
    common: {
      black: colors.black,
      white: colors.white,
    },
    primary: {
      main: colors.palatinateBlue,
    },
    secondary: {
      main: colors.blueViolet,
    },
    error: {
      main: colors.ruby,
    },
    warning: {
      main: colors.ruby,
    },
    info: {
      main: colors.shampoo,
    },
    success: {
      main: colors.persianGreen,
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    aside: {
      main: colors.maastrichtBlue,
      background: colors.blueViolet,
    },
    background: {
      default: colors.ghostWhite,
    },
    text: {
      primary: colors.blueViolet,
    },
  },
})

export const sizes = {
  drawerWidth: 258,
  contentWidth: 913, // 865,
  offset: 333,
}

export const theme = isFreshFinance() ? freshfinanceTheme : punkfinanceTheme
